import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

// import './App.css';
import { Route, Switch } from 'react-router-dom';

import { TvpLayout } from './containers';
// import App from './containers/TvpLayout/TvpLayout';

const AresLayout = React.lazy(() => import('./containers/AresLayout'));
// const TvpLayout = React.lazy(() => import('./containers/TvpLayout'));

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

class LayoutSelector extends PureComponent {
  componentDidMount() {
    document.documentElement.classList.add('ares-tvpLayout');
    const { isAuthenticated, tuwpzuw } = this.props;

    if (isAuthenticated && !tuwpzuw) {
      document.documentElement.classList.remove(
        ...document.documentElement.classList
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { isAuthenticated, tuwpzuw } = this.props;

    if (
      tuwpzuw !== prevProps.tuwpzuw ||
      isAuthenticated !== prevProps.isAuthenticated
    ) {
      document.documentElement.classList.add('ares-tvpLayout');

      if (isAuthenticated && !tuwpzuw) {
        document.documentElement.classList.remove(
          ...document.documentElement.classList
        );
      }
    }
  }

  render() {
    let Layout = TvpLayout;
    const { isAuthenticated, tuwpzuw } = this.props;

    if (isAuthenticated && !tuwpzuw) {
      Layout = AresLayout;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Loading...</title>
        </Helmet>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route
              path="/"
              name="layout"
              render={(props) => <Layout {...props} />}
            />
          </Switch>
        </React.Suspense>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    tuwpzuw:
      state.auth.user.programId === 'b6f47e72-716e-4e3d-9ce1-797637bf3b69'
  };
};

// const mapDispatchToProps = (dispatch) => {
//   // return { authCheckState: () => dispatch(authCheckState()) };
// };

export default connect(
  mapStateToProps
  // mapDispatchToProps
)(LayoutSelector);
